export default __webpack_public_path__ + "203fba89566e39fe86e57c72819664bc.svg";